export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE'
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS'
export const FETCH_USER_PROFILE_ERROR = 'FETCH_USER_PROFILE_ERROR'

export const ADD_FRIEND = 'ADD_FRIEND'
export const ADD_FRIEND_ERROR = 'ADD_FRIEND_ERROR'
export const ADD_FRIEND_SUCCESS = 'ADD_FRIEND_SUCCESS'

export const REMOVE_FRIEND = 'REMOVE_FRIEND'
export const REMOVE_FRIEND_ERROR = 'REMOVE_FRIEND_ERROR'
export const REMOVE_FRIEND_SUCCESS = 'REMOVE_FRIEND_SUCCESS'

export const WINK = 'WINK'
export const WINK_ERROR = 'WINK_ERROR'
export const WINK_SUCCESS = 'WINK_SUCCESS'

export const CHAT = 'CHAT'
export const CHAT_ERROR = 'CHAT_ERROR'
export const CHAT_SUCCESS = 'CHAT_SUCCESS'
